// removed by extract-text-webpack-plugin
module.exports = {"root":"video-metadata__root","sticky":"video-metadata__sticky","collectionTitle":"video-metadata__collectionTitle","title":"video-metadata__title","description":"video-metadata__description","sharingLinks":"video-metadata__sharingLinks","sharingLink":"video-metadata__sharingLink","metaProps":"video-metadata__metaProps","metaProp":"video-metadata__metaProp"};


//////////////////
// WEBPACK FOOTER
// ./src/show-page/components/video-metadata/styles.less
// module id = 498
// module chunks = 1